import { render, staticRenderFns } from "./exchangeConfig.vue?vue&type=template&id=26c5a82f&scoped=true"
import script from "./exchangeConfig.vue?vue&type=script&lang=js"
export * from "./exchangeConfig.vue?vue&type=script&lang=js"
import style0 from "./exchangeConfig.vue?vue&type=style&index=0&id=26c5a82f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c5a82f",
  null
  
)

export default component.exports